export const mediafiles = [
  {
    name: "salad-bowl",
    url:
      "https://images.pexels.com/photos/406152/pexels-photo-406152.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    type: "picture",
    _id: "1"
  }
];
